// extracted by mini-css-extract-plugin
export default {"container":"yOcw8lKS_zLT_xAevUbG"};